import { useToast } from "vue-toast-notification";

const toast = useToast();

export function errorToast(message) {
  toast.open({
    message,
    type: 'error',
    duration: 5000,
    position: 'top-right'
  });
}

export function infoToast(message) {
  toast.open({
    message,
    type: 'info',
    duration: 5000,
    position: 'top-right'
  });
}

export function warningToast(message) {
  toast.open({
    message,
    type: 'warning',
    duration: 5000,
    position: 'top-right'
  });
}
